import type { EmblaCarouselType } from 'embla-carousel';
import { useEffect } from 'react';

export function useAutoplayOnInView(
  emblaApi: EmblaCarouselType | undefined,
  inView: boolean,
) {
  useEffect(() => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) {
      return;
    }

    if (inView) {
      autoplay.play();
    } else {
      autoplay.stop();
    }
  }, [emblaApi, inView]);
}
